export default {
    actions: {
        getSettings(ctx, data) {
            let url = data.path + `/settingGet`;
            axios
                .get(url)
                .then(response => {
                    ctx.commit('updateSettings', response.data)
                })
        }
    },
    mutations: {
        updateSettings(state, settings) {
            state.settings = settings;
        }
    },
    state: {
        settings: [],
    },
    getters: {
        allSettings(state) {
            return state.settings
        }
    }
}
